<template>
  <div>
<!--    -=-={{selectedRange}}-->
    <v-date-picker
        is-range
        xmode="range"
        :value="null"
        :key="clock"
        color="red"
        is-dark
        is-inline
        v-if="selectedRange"
        v-model="selectedRange"
        @dayclick="selectDate"
        is-expanded

        :from-page="navTo"
        :disabled="!loaded"
        @update:to-page="monthChanged"
        :attributes="attributes"
        :available-dates="fromToday?{ start: new Date(), end: null }:null"
        :disabled-dates="notAvailableDates"
        @input="handleInput"
    />
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import _ from "lodash";
import * as dateHelper from "date-fns";
import * as api from "~/api/resource";

export default {
  name: "s-av-calendar",
  props: {
    startPlaceholder: {type: String, default: "from"},
    toPlaceholder: {type: String, default: "to"},
    value: {default: null},
    startProp: {type: String, default: "time"},
    endtProp: {type: String, default: null},
    fromToday: {type: Boolean, default: false},
    range: {type: Boolean, default: false},
    availabilityEndPoint: {type: Function, default: (range) => null},

    availabilityProcessor: {type: Function, default: (dataSetForDay) => 0}, //return load 0-100: 0 available 100 full {time,load}
  },
  data() {
    return {
      navTo: null,
      bookingPax: 1,
      clock: 1,
      selectedRange: null,
      selectedTripId: null,
      excursionsList: null,
      browsedExcrsId: null,
      browseRange: null,
      loaded: false,
      possibleDates: [],
      notAvailableDates: null,
      attributes: [
        {
          dot: {
            color: "red",
            class: "my-dot-class",
          },
          dates: [
            new Date(2018, 0, 1), // Jan 1st
            new Date(2018, 0, 10), // Jan 10th
            new Date(2018, 0, 22), // Jan 22nd
          ],
        },
        {
          dot: "green",
          dates: [
            new Date(2018, 0, 4), // Jan 4th
            new Date(2018, 0, 10), // Jan 10th
            new Date(2018, 0, 15), // Jan 15th
          ],
        },
        {
          dot: "purple",
          dates: [
            new Date(2018, 0, 12), // Jan 12th
            new Date(2018, 0, 26), // Jan 26th
            new Date(2018, 0, 15), // Jan 15th
          ],
        },
      ],
    };
  },
  watch: {
    value: {
      handler(v, vo) {
        _log_("[CALENDAR getMonthRange]", v, this.selectedRange);
        if (v?.start)
          this.navTo = {month: v.start.getMonth() + 1, year: v.start.getFullYear()}
        else if (this.selectedRange?.start)
          this.navTo = {month: this.selectedRange.start.getMonth() + 1, year: this.selectedRange.start.getFullYear()}
        //{ month: 1, year: 2019 }
        // return;
        // if (v && v != vo) {
        this.selectedRange = v;

        // this.attributes = [];
        this.attributes.push({
          key: "smarked",
          highlight: true,
          dates: v,
        });

        // }


      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleInput(e) {
      _log_("[CALENDAR input]", e);
      this.$emit("input", e);
    },
    selectDate(d) {
      //   const tripFound = this.findInArray(this.possibleDates, { day: d.day });
      //   if (tripFound) this.selectedTripId = tripFound.tripId;
      //   _log_("opa.." + d.isDisabled, d, tripFound);
    },
    getMonthRange(m, y) {
      let today = new Date();
      if (!m) m = today.getMonth() + 1;
      if (!y) y = today.getFullYear();

      return "1/" + m + "/" + y + "-1/" + (m + 1) + "/" + y;
    },
    async loadAvailability(browseRange) {
      // if (!this.loaded) return;
      _log_("loadAvailability [CALENDAR loadAvailability]", browseRange);
      if (!browseRange) return;
      this.loaded = false;
      let bookedData = await this.availabilityEndPoint(browseRange);
      const vm = this;
      // this.attributes = [];
      let //notAvailableDates = [],
          highDemant = [],
          lowDemant = [];
      this.notAvailableDates = [null];

      const dataAv = await this.availabilityProcessor(bookedData);

      // return;
      if (dataAv && dataAv.length) {
        dataAv.forEach((trip) => {
          const tripDate = new Date(trip.time);

          //   trip.pax = trip.pax ? trip.pax : 0;
          // _log_("check...", trip, tripDate);
          // vm.possibleDates.push(tripDate);

          // vm.possibleDates.push(tripDate);
          //  vm.possibleDates.push({
          //       start: tripDate,
          //       end: tripDate,
          //       day: tripDate.getDate()
          //     });
          if (trip.load >= 100) vm.notAvailableDates.push(tripDate);
          else if (trip.load >= 60) highDemant.push(tripDate);
          else lowDemant.push(tripDate);
        });
        this.attributes = [
          {
            bar: {
              color: "red",
              class: "my-dot-class",
            },
            dates: vm.notAvailableDates,
          },
          {
            bar: "orange",
            dates: lowDemant,
          },
          {
            bar: "red",
            dates: highDemant,
          },
        ];
      } else this.possibleDates = [null];
      this.loaded = true;
      _log_("loadAvailability reset..", vm.attributes);
    },
    async loadAvailableExcursions() {
      var excrss = await api.getModxList("tripservice");
      this.excursionsList = excrss;
    },
    async monthChanged(d) {

      _log_("loadAvailability monthChanged..", d);
      const nd = this.getMonthRange(d.month, d.year);
      if (nd != this.browseRange) {
        this.browseRange = nd;
        await this.loadAvailability(this.browseRange);
      }

      // _log_("hel..", d);
    },
    // ...mapActions({
    //   fetchRooms: "hotelinfo/fetchRooms",
    // }),

    goToBooking(data) {
      // _log_("bokk,,,", data);
      this.routeGo({
        name: "EditBooking",
        query: {bkid: data.row.idBooking},
      });
    },
  },
  async mounted() {
    // const nd = this.getMonthRange();
    // _log_("loadAvailability [CALENDAR MOUNT", nd);
    // // await this.loadAvailability(nd);
    //
    // this.attributes.push({
    //   key: "today",
    //   dot: true,
    //   dates: new Date(),
    // });
    this.loaded = true;

    // _log_("the rs///", this.rooms);
  },
  computed: {
    forServise() {
      return this.$route.params.tripServiseId
          ? this.$route.params.tripServiseId
          : this.browsedExcrsId;
    },
    xxattributes() {
      var av = [];
      return [
        {
          dot: {
            color: "red",
            class: "my-dot-class",
          },
          dates: [
            new Date(2018, 0, 1), // Jan 1st
            new Date(2018, 0, 10), // Jan 10th
            new Date(2018, 0, 22), // Jan 22nd
          ],
        },
        {
          dot: "green",
          dates: [
            new Date(2018, 0, 4), // Jan 4th
            new Date(2018, 0, 10), // Jan 10th
            new Date(2018, 0, 15), // Jan 15th
          ],
        },
        {
          dot: "purple",
          dates: [
            new Date(2018, 0, 12), // Jan 12th
            new Date(2018, 0, 26), // Jan 26th
            new Date(2018, 0, 15), // Jan 15th
          ],
        },
      ];
    },
    ...mapGetters({
      rooms: "hotelinfo/rooms",
    }),
    qBookings() {
      return {"bookingRange[]": bookingRange, searchall: searchall};
    },

    colDefinitions() {
      var rw = "380px";
      if (window.innerWidth < 500) rw = "150px";
      if (window.innerWidth < 700) rw = "240px";
      if (window.innerWidth < 1000) rw = "300px";
      return [
        // {
        //   prop: "paymentStatus",
        //   width: "120px",
        //   label: "Πληρωμή",
        //   displayClass: "el-tag el-tag--info",
        //   component: {
        //     is: "v-payment"
        //   }
        // },
        {prop: "refNum", width: "", label: "Αρ.Κρατησης"},
        {prop: "bookingDateF", width: "", label: "Ημερ.Κράτησης"},

        {prop: "firstName", width: "", label: "Ονομα"},

        {
          prop: "roomsF",
          width: rw,
          label: "Κράτηση",
          displayClass: "el-tag el-tag--info",
          component: {
            is: "v-rooms",
          },
        },
        // {
        //   prop: "asset_id",
        //   width: "180px",
        //   label: "Vehicle",
        //   editable: true,
        //   component: {
        //     is: "s-select",
        //     optionsRepo: this.vehicles,
        //     labelProp: "name",
        //     valueProp: "id",
        //     filterable: true,
        //     clearable: true
        //   }
        // },
        // {
        //   prop: "driver_contact_id",
        //   width: "180px",
        //   label: "Driver",
        //   editable: true,
        //   component: {
        //     is: "s-select",
        //     optionsRepo: this.calcDriverList,
        //     labelProp: "name",
        //     valueProp: "id",
        //     filterable: true,
        //     clearable: true
        //   }
        // },
        // {
        //   prop: "escort_contact_id",
        //   width: "180px",
        //   label: "Agent",
        //   editable: true,
        //   component: {
        //     is: "s-select",
        //     optionsRepo: this.escortList,
        //     labelProp: "name",
        //     valueProp: "id",
        //     filterable: true,
        //     clearable: true
        //   }
        // },
        // { prop: "destination", width: "180px", label: "Destination" },
        // { prop: "coname", width: "180px", label: "coname" }
      ];
    },
  },
};
</script>

<style>
.search.x-row {
  align-items: flex-start;
}

.has-more {
  color: red;
  font-weight: 700;
}

span.vc-bg-green-600 {
  height: 30px !important;
  opacity: 20%;
}
</style>

